import styled from 'styled-components';

import {Device} from '../../../../constants';

const VBucksImage = styled.img`
  display: block;
  width: auto;
  height: 110%;
  transform: translate3d(18%, 0px, 1px);
  flex: 0 1 auto;

  @media screen and (max-width: 1245px) {
    transform: translate3d(25vw, 0px, 1px);
  }

  @media screen and (max-width: 975px) {
    width: 120%;
    height: auto;
    transform: translate3d(0px, 0px, 0px);
  }
  @media screen and ${Device.mobileL} {
    width: 750px;
  }
`;

export default VBucksImage;
